module.exports = __webpack_public_path__ + "static/media/004-woman.a53cf6f9.svg";